import React, { Component } from "react";
import { observer } from "mobx-react";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import LoadingImage from "../../../comum/components/LoadingImage";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Col, Row, Container } from "reactstrap";
import CardMovimentacao from "./CardMovimentacao";
import { buscaFiltrarVazio } from '../../../../utils/mensagens';
import { HeaderTableFixed } from "../../../../utils/headerTableFixed";
import { arrayIsEmpty } from "../../../../utils/functions";

@observer
export class TabelaMovimentacao extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;

        window.addEventListener('scroll', HeaderTableFixed);
    }

    render() {

        let lista = this.controller.listaItens.length > 0 ? this.controller.listaItens : [];
        let loading = this.controller.loading;

        return (
            !this.controller.filtrado || arrayIsEmpty(this.controller.colunas)
                ? <Row>
                    <Col className="mt-3" xs={12}>
                        <span className="mensagem-filtrar">
                            {!this.controller.filtrado ? buscaFiltrarVazio : "Nenhum campo para exibição foi informado, favor verificar em Customizar"}
                        </span>
                    </Col>
                </Row>
                : <ToolkitProvider
                    keyField="NavioNome"
                    data={lista.slice()}
                    columns={[...this.controller.colunas]}>
                    {props => (

                        window.innerWidth > 991 ?
                            <div id="tableHeaderFixed" className="tabela-overflow">
                                <BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    noDataIndication={() => loading ?
                                        <div className="float-left"><LoadingImage /></div> : (this.controller.filtrado && this.controller.tableMessage)}
                                    classes="tabela tabela-layout"
                                    pagination={paginationFactory()}
                                    {...props.baseProps} />
                            </div>
                            :
                            <Row>
                                {loading ?
                                    <LoadingImage />
                                    :
                                    lista.map((card, x) => (
                                        <CardMovimentacao
                                            controller={this.controller}
                                            key={x}
                                            data={card}
                                            id={x}
                                            colunas={[...this.controller.colunas]}
                                        // titulo={"NavioNome"}
                                        // subtitulo={"Viagem"}

                                        />
                                    ))}
                            </Row>
                    )}
                </ToolkitProvider>

        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/movimentação/components/TabelaMovimentacao.js